import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { UniversalPlayer } from '@/components/player/UniversalPlayer';
import { AudioProvider } from '@/contexts/AudioContext';

export function Layout() {
  return (
    <AudioProvider>
      <div className="min-h-screen flex flex-col">
        <div className="sticky top-0 z-50">
          <Header />
        </div>
        <main className="flex-1 pb-44 sm:pb-48 lg:pb-28">
          <Outlet />
        </main>
        <div className="pb-44 sm:pb-48 lg:pb-28">
          <Footer />
        </div>
        <UniversalPlayer />
      </div>
    </AudioProvider>
  );
}
